exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  color: #4b81b0 !important;\n  margin-bottom: 10px !important; }\n\n.errorLabel {\n  font-size: 12px;\n  color: red;\n  margin-left: 10px;\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/number-edit-dialog/number-edit-dialog.component.scss
// module id = ../../../../../src/app/components/common/dialog/number-edit-dialog/number-edit-dialog.component.scss
// module chunks = 0